import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaXTwitter,
  FaLinkedinIn,
  FaFacebookF,
  FaYoutube,
} from 'react-icons/fa6';
import './Footer.css';
import logo from '../../assets/images/logo.png';

const QUICK_LINKS = [
  { to: '/',           label: 'Home'       },
  { to: '/about',      label: 'About NSK'  },
  { to: '/team',       label: 'Our Team'   },
  { to: '/membership', label: 'Membership' },
  { to: '/blog',       label: 'Blog'       },
  { to: '/gallery',    label: 'Gallery'    },
  { to: '/contact',    label: 'Contact'    },
];

const RESOURCE_LINKS = [
  { to: 'https://www.iaea.org/',          label: 'IAEA'        },
  { to: 'https://www.nuclear.co.ke/',     label: 'NuPEA Kenya' },
  { to: 'https://knra.co.ke/',            label: 'KNRA Kenya'  },
  { to: 'https://www.kengen.co.ke/',      label: 'KenGen'      },
];

const SOCIAL_LINKS = [
  {
    href:  'https://x.com/KenyaNuclearSoc',
    label: 'NSK on X (Twitter)',
    icon:  <FaXTwitter size={16} />,
  },
  {
    href:  'https://www.linkedin.com/company/nuclear-society-of-kenya/',
    label: 'NSK on LinkedIn',
    icon:  <FaLinkedinIn size={16} />,
  },
  {
    href:  'https://www.facebook.com/p/Nuclear-Society-of-Kenya-61564652765701/',
    label: 'NSK on Facebook',
    icon:  <FaFacebookF size={16} />,
  },
  {
    href:  'https://youtube.com/@NSKKenya',
    label: 'NSK on YouTube',
    icon:  <FaYoutube size={16} />,
  },
];

const NSK_EMAIL   = 'info@nuclearsocietyofkenya.org';
const currentYear = new Date().getFullYear();

function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__top">

        {/* Brand Column */}
        <div className="footer__brand">
          <Link
            to="/"
            className="footer__logo"
            aria-label="Nuclear Society of Kenya — Home"
          >
            <img
              src={logo}
              alt="NSK Logo"
              className="footer__logo-img"
            />
            <div className="footer__logo-text">
              <span className="footer__logo-title">Nuclear Society</span>
              <span className="footer__logo-sub">of Kenya</span>
            </div>
          </Link>

          <p className="footer__tagline">
            Advancing nuclear science, technology, and policy for Kenya's
            sustainable energy future.
          </p>

          {/* Social Links */}
          <div className="footer__socials">
            {SOCIAL_LINKS.map(({ href, label, icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label={label}
              >
                {icon}
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer__col">
          <h2 className="footer__col-title">Quick Links</h2>
          <nav aria-label="Footer quick links">
            <ul className="footer__links">
              {QUICK_LINKS.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="footer__link">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        {/* Resources */}
        <div className="footer__col">
          <h2 className="footer__col-title">Resources</h2>
          <ul className="footer__links">
            {RESOURCE_LINKS.map(({ to, label }) => (
              <li key={label}>
                <a
                  href={to}
                  className="footer__link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer__col">
          <h2 className="footer__col-title">Contact</h2>
          <div className="footer__contact-item">
            <span className="footer__contact-label">Email</span>
            <a
              href={`mailto:${NSK_EMAIL}`}
              className="footer__contact-value footer__link"
            >
              {NSK_EMAIL}
            </a>
          </div>
          <div className="footer__contact-item">
            <span className="footer__contact-label">Location</span>
            <span className="footer__contact-value">Nairobi, Kenya</span>
          </div>
          <div className="footer__contact-item">
            <span className="footer__contact-label">Membership</span>
            <Link to="/join" className="footer__link">
              Apply to join NSK →
            </Link>
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <p className="footer__copyright">
            © {currentYear} <span>Nuclear Society of Kenya</span>. All rights reserved.
          </p>
          <nav aria-label="Footer legal links">
            <ul className="footer__bottom-links">
              <li>
                <Link to="/privacy-policy" className="footer__bottom-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <span className="footer__dot" aria-hidden="true">·</span>
              </li>
              <li>
                <Link to="/terms" className="footer__bottom-link">
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}

export default Footer;